import { ConfirmDialog } from "primereact/confirmdialog";

type ConfirmationModalProps = {
  visible: boolean;
  onHide: () => void;
  accept: () => void;
  reject: () => void;
};

export function ConfirmationModal({
  visible,
  onHide,
  accept,
  reject,
}: ConfirmationModalProps) {
  return (
    <ConfirmDialog
      visible={visible}
      onHide={onHide}
      message="Are you sure you want to proceed?"
      draggable={false}
      header="Confirmation"
      icon="pi pi-exclamation-triangle"
      accept={accept}
      reject={reject}
    />
  );
}
